import InstaTaskSidebarCopyItem from './InstaTaskSidebarCopyItem';

export default InstaTaskSidebarCopyItem;
